export default __webpack_public_path__ + "static/media/imagen2.a0849b62.webp";